var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { feathersServices } from 'src/feathers';
import { setWorkspaceMainEvents } from 'src/reducers/workspaceMain/actions';
import Page from '../../templates/Page';
import FormEvent from './FormEvent';
var FormEventPage = (function (_super) {
    __extends(FormEventPage, _super);
    function FormEventPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFindEvent = _this.handleFindEvent.bind(_this);
        _this.handleCreateEvent = _this.handleCreateEvent.bind(_this);
        _this.handlePatchEvent = _this.handlePatchEvent.bind(_this);
        _this.handleDeleteEvent = _this.handleDeleteEvent.bind(_this);
        _this.navigateTo = _this.navigateTo.bind(_this);
        return _this;
    }
    FormEventPage.prototype.handleFindEvent = function (subdomain, $limit) {
        if ($limit === void 0) { $limit = 0; }
        return this.props.dispatch(feathersServices.events.find({
            query: { subdomain: subdomain, $limit: $limit },
        }));
    };
    FormEventPage.prototype.handleCreateEvent = function (event) {
        var _this = this;
        return this.props.dispatch(feathersServices.events.create(event))
            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var workspaceMainEvents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        workspaceMainEvents = [response.value].concat(this.props.workspaceMain.events);
                        return [4, this.props.dispatch(setWorkspaceMainEvents({
                                total: this.props.workspaceMain.events.length + 1,
                                data: workspaceMainEvents,
                            }))];
                    case 1:
                        _a.sent();
                        return [2, response];
                }
            });
        }); });
    };
    FormEventPage.prototype.handlePatchEvent = function (event) {
        return this.props.dispatch(feathersServices.events.patch(event.id, event));
    };
    FormEventPage.prototype.handleDeleteEvent = function (event) {
        return this.props.dispatch(feathersServices.events.remove(event.id));
    };
    FormEventPage.prototype.navigateTo = function (path) {
        this.props.dispatch(push(path));
    };
    FormEventPage.prototype.render = function () {
        var event = this.props.workspaceEvent.event;
        var documentTitle = event
            ? "Edit event | " + event.nameShort
            : 'Setup a new event';
        return (React.createElement(Page, { documentTitle: documentTitle, pageTitle: event ? event.name : 'Setup new event', pageContentMaxWidth: '1024px' },
            React.createElement(FormEvent, { user: this.props.workspaceMain.user, event: event, handleFindEvent: this.handleFindEvent, handleCreateEvent: this.handleCreateEvent, handlePatchEvent: this.handlePatchEvent, handleDeleteEvent: this.handleDeleteEvent, navigateTo: this.navigateTo })));
    };
    return FormEventPage;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceMain: {
        user: state.workspaceMain.user && state.workspaceMain.user.data[0],
        events: state.workspaceMain.events && state.workspaceMain.events.data,
    },
    workspaceEvent: {
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
    },
}); };
export default connect(mapStateToProps)(FormEventPage);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormEventPage/index.tsx
// module id = 1102
// module chunks = 0